import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { OverviewContainer } from '../portfolio/overview/container';

export const DetailedViewContainer: React.ComponentType<RouteComponentProps<never>> = (props) => (
  React.createElement(OverviewContainer, { ...props, detailedViewOnly: true })
);
